import { useMutation } from "@tanstack/react-query";
import { editableTextUpdate } from "common/api/sakusas/sakusas_editable_text";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseSakusasEditableTextUpdateParams = {
  invalidateKeys?: string[];
};

export const useSakusasEditableTextUpdate = (
  hookParams?: UseSakusasEditableTextUpdateParams
) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: editableTextUpdateMutate } = useMutation({
    mutationFn: async (params: any) =>
      await editableTextUpdate(params.id, params.updatePayload),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }
    },
  });

  return { editableTextUpdateMutate };
};
